var metaInfo={
    title:"原材料加工_Movibot解决方案",
    keywords:"原材料加工_金属切割_伺服驱动器",
    description:"我们的可为原材料加工行业提供伺服驱动器解决方案。",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/10.js